var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "SI_4L_fill_green",
    cx: 21,
    cy: 21,
    r: 19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_green_compl",
    d: "M33.44 15.43L20.05 28.81l-2.16 2.16c-.38.38-1 .38-1.38 0l-7.52-7.52c-.38-.38-.38-1 0-1.38l2.16-2.16c.38-.38 1-.38 1.38 0l4.68 4.68 12.69-12.7a.996.996 0 011.41 0l2.13 2.12c.39.39.39 1.03 0 1.42z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.dad7a83792d349e89b918dd02f721f6c.svg";
export { ForwardRef as ReactComponent };